import React from "react";
import Grid from "@mui/material/Grid";
import "./backBtn.scss";
import { useNavigate } from "react-router-dom";
import commonImages from "../../../assets";
import { useThemeContext } from "../../../context";

const BackBtn = (props) => {
  const { mode } = useThemeContext();
  const navigate = useNavigate();

  return (
    <Grid
      className="backBtn"
      data-testid={props?.testId || "back-btn"}
      onClick={() =>
        props?.onClick
          ? props.onClick()
          : navigate(props?.dataBack?.route, {
              state: props?.dataBack?.state
                ? props?.dataBack?.state
                : {
                    backTabId: props?.dataBack?.backTabId ?? "",
                    projectName: props?.dataBack?.projectName,
                    projectNumber: props?.dataBack?.projectNumber,
                    projectid: props?.dataBack?.projectid,
                    stateId: props?.dataBack?.stateId,
                    customerName: props?.dataBack?.customerName,
                    customerId: props?.dataBack?.customerId,
                    editMode: props?.dataBack?.editMode
                      ? props?.dataBack?.editMode
                      : false,
                    islesson: props?.dataBack?.islesson,
                    iscourseNavigatePage:
                      props?.dataBack?.iscourseNavigatePage ?? null,
                  },
            })
      }
    >
      <Grid className="backImg">
        <img
          src={
            mode === "dark" ? commonImages.backBtnDark : commonImages?.backBtn
          }
          alt=""
        />
      </Grid>
      <Grid className="backTitle">{props?.dataBack?.title}</Grid>
    </Grid>
  );
};

export default BackBtn;
